import { querySharedServices } from '@/src/domains/shared/services';
import { queryPaidContractorFairpricingLandingPage } from '@/src/views/ContractorFairpricing/paid/services';

export { PaidContractorFairpricingView as default } from '@/src/views/ContractorFairpricing/paid';

export async function getStaticProps({ preview = false, previewData = {}, locale }) {
  const contractorFairpricingView = await queryPaidContractorFairpricingLandingPage({
    previewData,
    locale,
  });
  if (!contractorFairpricingView) {
    return {
      notFound: true,
    };
  }

  const sharedServices = await querySharedServices({ previewData, locale });

  return {
    props: {
      preview,
      sharedServices,
      ...contractorFairpricingView,
    },
  };
}
